import React, { useEffect } from 'react';
import './Cart.scss';
import { useDispatch, useSelector } from 'react-redux';
import * as cartActions from '../../../../actionCreators/cart';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const Cart = () => {
  const cart = useSelector(state => state?.header?.mainNavigationData?.cart);
  const cartCount = useSelector(state => state?.common?.isCartCount);
  const dispatch = useDispatch();

  useEffect(() => {
    if (cartCount > 0) {
      dispatch(cartActions.getCart());
    }
  }, [cartCount]);

  if (cart) {
    return (
      <a className="odCart" href={cart.link} onClick={() => triggerDataLayerOnCtaClick('cart')}>
        {cartCount > 0 ? <span className="odCart__count">{cartCount}</span> : null}
        <img alt={cart.alt} className="odCart__icon" src={cart.src} />
      </a>
    );
  }

  return null;
};

export default Cart;
